import {NDVSClient} from "../../client/NDVSClient";
import {EwayBillActions} from "../actions/EwayBillActions";
import Moment from "moment";

export function fetchEwayBillDetails(dispatcher) {

    NDVSClient.fetchActiveLmVRIDsForStation({
    }).then((response) => {
        if (response.valid) {
            var lmVRIDDetailList = response
                .data.lmVRIDDetailsList
                .map(({
                          lmVRID, nodeId, creationTime, lastUpdatedTime, lastUpdatedBy, packageBarcodes
                      }) => ({
                    LMVRID: lmVRID || "",
                    LAST_UPDATED_TIME: lastUpdatedTime ? Moment(lastUpdatedTime).format("YYYY-MM-DD h:mm A") :
                                                        Moment().format("YYYY-MM-DD h:mm A"),
                    CREATION_TIME: creationTime ? Moment(creationTime).format("YYYY-MM-DD h:mm A") : Moment().format("YYYY-MM-DD h:mm A"),
                    LAST_UPDATED_BY: lastUpdatedBy || "DEFAULT_IN_OPERATOR",
                    PACKAGE_BARCODES: packageBarcodes || []
                }));
            dispatcher({
                type: EwayBillActions.SET_LMVRID_DETAILS,
                data: lmVRIDDetailList
            })
        } else {
            dispatcher({
                type: EwayBillActions.SET_ERROR_WHILE_FETCHING_LMVRIDS
            })
        }
    });
}

export function downloadEwayBill(dispatcher, lmVRID) {

    NDVSClient.downloadEwayBill({
        lmVRID : lmVRID
    }).then((response) => {
        if (response.valid) {
            var eWayBillPdfString = response.data.eWayBillPdf
            createEwayBillPdf(dispatcher, eWayBillPdfString)
        } else {
            dispatcher({
                type: EwayBillActions.SET_ERROR_WHILE_FETCHING_EWAYBILL,
            })
        }
    });
}

export function createEwayBillPdf(dispatcher, eWayBillPdfString) {
            try {
                const base64String = eWayBillPdfString;
                const blob = base64toBlob(base64String);
                const fileURL = URL.createObjectURL(blob);
                window.open(fileURL);
            } catch (e) {
                dispatcher({
                    type: EwayBillActions.SET_ERROR_WHILE_CREATING_PDF,
                })
            }

}

const base64toBlob = (base64WithoutPrefix) => {
    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
        out[length] = bytes.charCodeAt(length);
    }
    return new Blob([out], { type: 'application/pdf'});
};




// WEBPACK FOOTER //
// ./src/components/eWayBill/network/EwayBillDetailsAPI.js